import skeleton from '../../../components/skeleton';
import './lianTuoCompany.less'
import banner from "../../../components/banner";
export default {
    name: "lianTuoCompany",
    data() {
        return {
            introduce: {
                title: '联拓数科用数字科技连接私域流量与线下商业<br/>秉承联合比独立更有价值的理念，致力于推动中国线下商业数字化进程',
                info: [
                    '公司业务主要基于腾讯、阿里生态',
                    '连接移动支付、卡券、小程序商城、公众号、企业微信、腾讯直播和网商云资金，',
                    '为线下商户提供线上线下一体化、全渠道的营销数字化解决方案，',
                    '帮助线下商户实现交易在线、组织在线、客户在线、服务在线、店务在线、财务在线的数字化升级。',
                    '从而重构传统商业的人、钱、货、场。'
                ]
            },
            survey: [
                {
                    title: '概况',
                    infoPc: '联拓数科总部在北京，<br/>具有18年交易平台积淀，<br/>10年移动支付经验。<br/>现有研发团队100+，<br/>渠道销售体系3000+，<br/>合作线下餐饮、零售、加油站等商户58万＋。',
                    infoWap: '联拓数科总部在北京，<br/>具有18年交易平台积淀，<br/>10年移动支付经验。<br/>现有研发团队100+，<br/>渠道销售体系3000+，<br/>合作线下餐饮、零售、加油站等商户58万＋。',
                    pic: 'img/lianTuoCompany/survey1.png',
                    block: ''
                },
                {
                    title: '市场特色',
                    infoPc: '渠道下沉及零售业中长尾商户是联拓的特色之一 ,<br/>3000+遍布城市与乡镇的软件服务商大军，<br/>在联拓数科的带领下,<br/>凭借“收款小精灵，收银黑科技”的强大产品能力，<br/>成为了移动支付营销在零售行业的专业落地者。',
                    infoWap: '渠道下沉及零售业中长尾商户是联拓的特色之一 ,3000+遍布城市与乡镇的软件服务商大军。<br/>在联拓数科的带领下,c凭借“收款小精灵，收银黑科技”的强大产品能力，成为了移动支付营销在零售行业的专业落地者。',
                    pic: 'img/lianTuoCompany/survey2.png',
                    block: 'swap'
                },
                {
                    title: '从一个小插件开始',
                    infoPc: '数字化和黑科技是联拓基因的构成之一 ,<br/>明星产品收款小精灵通过领先的收银系统打通能力，<br/>无缝对接市场上绝大多数传统收银软件，<br/>10分钟快速打通收银软件单品。<br/>在此之上的数字化营销工具更符合线上商户的业务应用。',
                    infoWap: '数字化和黑科技是联拓基因的构成之一 ,明星产品收款小精灵通过领先的收银系统打通能力，无缝对接市场上绝大多数传统收银软件，10分钟快速打通收银软件单品。<br/>在此之上的数字化营销工具更符合线上商户的业务应用。',
                    pic: 'img/lianTuoCompany/survey3.png',
                    block: ''
                },
                {
                    title: '开放思维',
                    infoPc: '连接及资源整合能力体现联拓的版图思维，通过开放合作和输出型思维,<br/>我们与广西烟草、光大银行、交通银行、客商银行、汇付天下在业务拓展与系统层面合作;<br/>同时，我们也正在与更多的软件品牌商和开发者们深度合作，共同赋能线下新零售。',
                    infoWap: '连接及资源整合能力体现联拓的版图思维，通过开放合作和输出型思维,我们与广西烟草、光大银行、交通银行、客商银行、汇付天下在业务拓展与系统层面合作。<br/>同时，我们也正在与更多的软件品牌商和开发者们深度合作，共同赋能线下新零售。',
                    pic: 'img/lianTuoCompany/survey4.png',
                    block: 'swap'
                }
            ],
            manage: [
                {
                    name: '陈鹏',
                    pic: 'img/lianTuoCompany/manage1.png',
                    position: '创始人&董事长'
                },
                {
                    name: '冯红兵',
                    pic: 'img/lianTuoCompany/manage2.png',
                    position: 'CEO'
                },
                {
                    name: '卡拉拉',
                    pic: 'img/lianTuoCompany/manage3.png',
                    position: 'COO'
                },
                {
                    name: '刘冬',
                    pic: 'img/lianTuoCompany/manage4.png',
                    position: '业务副总裁'
                },
                // {
                //     name: '牛晓宇',
                //     pic: 'img/lianTuoCompany/manage5.png',
                //     position: '支付生态副总经理'
                // },
                // {
                //     name: '赵宇',
                //     pic: 'img/lianTuoCompany/manage6.png',
                //     position: '产研副总裁'
                // }
            ],
            talk: {
                info: [
                    '“ 我们在联拓数科的工作直接影响我们的商家，这就是我们日以继夜、孜孜不倦的原因，做出真正有意义的决定，并对每个细节认真负责。”'
                ]
            },
            course: [
                {
                    year: '2013',
                    info: '9月，合肥联拓富数字科技有限公司（简称：联拓数科），致力于为线下零售业提供企业钱包saas服务，<br/>12月，合肥联拓富数字科技有限公司北京分公司正式成立，<br/>通过“资金管理"平台“帮助线下连锁业实现收、付、账、贷一站式资金管理平台，获得联想之星和光信资本的投资。'
                },
                {
                    year: '2015',
                    info: '10月，企业钱包升级联富通平台，赋能银行提供移动支付云平台和零售行业场景金融。'
                },
                {
                    year: '2017',
                    info: '3月, 正式发布收银科技产品 —— <span style="color:#5AC8FA; font-size: 16px;">收款小精灵</span>，<br/>聚焦零售行业、拓展服务商体系，当年的使用商家获得快速的增长。'
                },
                {
                    year: '2018',
                    info: '9月，正式发布小精灵营销产品，成为行业内有口皆碑的营销Saas产品。'
                },
                {
                    year: '2019',
                    info: '6月，联拓金融正式更名为联拓数科，提出新的使命为“用数字科技连接私域流量与线下商业”。'
                },
                {
                    year: '2020',
                    info: '4月，正式发布线上化产品，包括小程序商城和外卖，为疫情期间的商家创造更多的生意机会。'
                },
                {
                    year: '2021',
                    info: '6月1日，于厦门正式发布“小精灵数字加油站”，为小精灵营销SaaS的行业垂直化开启第一个里程碑。'
                },
                {
                    year: '2022',
                    info: '11月，正式发布餐饮收银一体化的数字解决方案，小程序扫码点餐整体优化升级。联+机构合作业务发展迅猛。'
                },
                {
                    year: '2023',
                    info: '5月14日，母亲节当日峰值笔数破1000万笔，日活门店数达到77000家，累计覆盖50万家门店使用，覆盖门店会员数破8000万人次。'
                }
            ]
        }
    },
    components: {
        skeleton,
        banner,
    }
}
